import 'application.sass';

import initMatchHeight from './initMatchHeight'
import initScroll from './initScroll';

initMatchHeight();
initScroll();
